const listeners = new Set();

export const toast = {
  success: (message) => {
    listeners.forEach(cb => cb({ type: 'success', message }));
  },
  error: (message) => {
    listeners.forEach(cb => cb({ type: 'error', message }));
  },
  warning: (message) => {
    listeners.forEach(cb => cb({ type: 'warning', message }));
  },
  info: (message) => {
    listeners.forEach(cb => cb({ type: 'info', message }));
  },
  subscribe: (cb) => {
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  }
};
